// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__26oSm","row":"ProcedureTreatmentSummary_row__1kbrT"};